module.exports = __webpack_public_path__ + "img/hunt_goods_pri.271b93ab.png";